import request from '@/utils/request'

let TansferApi = {
  /*赠送列表*/
  getTransferList(data, errorback) {
    return request._post('/shop/plus.transfer.transfer/index', data, errorback);
  },
  /*添加赠送记录*/
  addTransfer(data, errorback) {
    return request._post('/shop/plus.transfer.transfer/add', data, errorback);
  },
  /*删除赠送记录*/
  deleteArticle(data, errorback) {
    return request._post('/shop/plus.transfer.transfer/delete', data, errorback);
  },
  editArticle(data, errorback) {
    return request._post('/shop/plus.transfer.transfer/edit', data, errorback);
  },
  /*文章详情*/
  toEditTransfer(data, errorback) {
    return request._get('/shop/plus.transfer.transfer/edit', data, errorback);
  },


}
export default TansferApi;



// WEBPACK FOOTER //
// ./src/api/transfer.js